import { ActionType, ProColumns, ProTable } from '@ant-design/pro-components';
import { DatePicker, Form } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { ReportAverageRatingOverTimeModel } from 'services/Main/reportVisitCustomerSR';
import { commonPresenter, commonStore, reportVisitCustomerSRPresenter, reportVisitCustomerSRStore } from 'stores/root_store';
import { DATE_FORMAT_POST, VARIABLE_CHECK_ZALO } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { getsaleOrg } from 'utils/localStorageHelper';
import CustomBarChartBC4 from './chartTable';

const { RangePicker } = DatePicker;


// BÁO CÁO ĐIỂM ĐÁNH GIÁ TRUNG BÌNH THEO THỜI GIAN =========================================================
const createPageAverageRatingOverTime = () => {
  return observer(() => {

    //=====================================CHUYỂN NGÔN NGỮ=================================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [dataReport, setDataReport] = useState<ReportAverageRatingOverTimeModel[]>([])
    // const disablefield = useWatch('radioGroup', form)


    const [dataName, setDataName] = useState<string[]>([])
    const [dataCol1, setDataCol1] = useState<number[]>([])
    const [dataCol2, setDataCol2] = useState<number[]>([])
    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      env: VARIABLE_CHECK_ZALO,
      isShowroom: true
    });

    // data common date
    const [listCommonDate, setListCommonDate] = useState<CommonModel[]>([]);
    // disable rangePicker khi chọn ngày từ common
    const [disableRangePicker, setDisableRangePicker] = useState(false);

    const [loading, setLoading] = usePartialState({
      loadingSearch: false,
      loading: false,
    })

    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns<ReportAverageRatingOverTimeModel>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 50,
        onCell: (_, index) => ({
          className: 'text-center',
        }),
        align: 'center',
      },
      // Showroom
      {
        title: 'Showroom',
        dataIndex: 'storeName',
        key: 'storeName',
        fixed: 'left',
        render: (_, record) => {
          return <div>
            {record.storeName}
          </div>
        }
      },
      // Số lượt ghé thăm
      {
        title: 'Điểm đánh giá trung bình',
        dataIndex: 'diemDanhGiaTB',
        key: 'diemDanhGiaTB',
        render: (_, record) => {
          return <div>{formatNumber(record.diemDanhGiaTB, 0)}</div>
        },
        onCell: () => ({ style: { textAlign: 'right' } }),
        width: 100,
      },
      // lượt đánh giá
      {
        title: 'Điểm đánh giá trung bình kỳ so sánh',
        dataIndex: 'diemDanhGiaTB2',
        key: 'diemDanhGiaTB2',
        render: (_, record) => {
          return <div>{formatNumber(record.diemDanhGiaTB2, 0)}</div>
        },
        onCell: () => ({ style: { textAlign: 'right' } }),
        width: 100,
      },
    ];

    // ============================================ ===========================================================================
    const tableRef = useRef<ActionType>();
    // Hàm lấy data danh sách công ty =================================================================
    // const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    // công ty
    const [listSaleOrg, setListSaleOrg] = useState<CommonModel[]>([]);

    const [open, setOpen] = usePartialState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };

    const getListSaleOrg = async () => {
      await commonPresenter.getListSaleOrg(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListSaleOrg(commonStore.commonRespone.data);
      }
    };

    // Lấy  danh sách người tạo
    // const getListCreateBy = async (key = '') => {
    //   await commonPresenter.getListPersonInCharge(commonStore, key);
    //   if (commonStore.commonRespone.isSuccess) {
    //     setListCreateBy(commonStore.commonRespone.data);
    //   }
    // };
    // const searchCreateBy = useDebounce(getListCreateBy, 500);


    // Lấy danh sách common date
    const getListCommonDate = async () => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getListSelectCommonDate(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCommonDate(commonStore.commonRespone.data);
      }
      setLoading({ loadingSearch: false })
    };

    // Lấy ngày bằng common data
    const getDateByKey = async (key: string) => {
      setLoading({ loadingSearch: true })
      await commonPresenter.getDateByCommonDate(commonStore, key);
      if (commonStore.commonDate.fromDate) {
        setDataSearch({
          ...dataSearch,
          fromTime: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
          toTime: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
          fromTimeBefore: commonStore.commonDate.fromDate ? dayjs(commonStore.commonDate.fromDate)?.format(DATE_FORMAT_POST) : undefined,
          toTimeBefore: commonStore.commonDate.toDate ? dayjs(commonStore.commonDate.toDate)?.format(DATE_FORMAT_POST) : undefined,
          companyId: form.getFieldValue('companyId'),
        });

        form.setFieldValue("ngayDanhGia", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);


      } else {
        form.setFieldValue("ngayDanhGia", undefined);
      }
      setLoading({ loadingSearch: false })
    };


    // Hàm lấy data danh sách công ty =================================================================
    const [listBranch, setListBranch] = useState<CommonModel[]>()


    // chi nhánh
    const getListBranch = async (company: string) => {
      await commonPresenter.getBranchByCompany(commonStore, company)
      setListBranch(commonStore.commonRespone.data)
    };

    // Lấy công ty cụ thể theo saleOrg
    const getCompanyBySaleOrg = async () => {
      await reportVisitCustomerSRPresenter.getCompanyBySaleOrg(reportVisitCustomerSRStore, getsaleOrg());

      if (reportVisitCustomerSRStore.companyBySaleOrg.data) {
        form.setFieldValue('companyId', reportVisitCustomerSRStore.companyBySaleOrg.data)

        setDataSearch({
          ...dataSearch,
          companyId: reportVisitCustomerSRStore.companyBySaleOrg.data
        });
      }
    }



    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {
      await reportVisitCustomerSRPresenter.getDataReportDDGTBTTG(reportVisitCustomerSRStore, dataSearch);
      if (reportVisitCustomerSRStore.reportDDGTBTTG.isSuccess) {
        const dataTemp = cloneDeep(reportVisitCustomerSRStore.reportDDGTBTTG.data);
        setDataReport(dataTemp);

        dataTemp.pop()

        setDataName(dataTemp.map(item => {
          return item.storeName
        }))

        setDataCol1(dataTemp.map(item => item.diemDanhGiaTB))
        setDataCol2(dataTemp.map(item => item.diemDanhGiaTB2))

        return dataTemp;
      }
      setDataReport([]);
      return [];
    }


    //================================================================================================
    //================================================================================================
    //================================================================================================
    useEffect(() => {
      (async () => {
        getListSaleOrg();
        // getListCreateBy();
        await getListCommonDate()
        // set value ban đầu
        form.setFieldValue('commonDate', 'LastMonth')
        await getCompanyBySaleOrg()
        await getDateByKey('LastMonth')
        await getListBranch(form.getFieldValue('companyId'))
        setDisableRangePicker(true)

        // set initvalue cho kì trước
        form.setFieldValue("kyTruoc", [
          dayjs(commonStore.commonDate.fromDate),
          dayjs(commonStore.commonDate.toDate),
        ]);

        tableRef.current?.reload();
      })()
    }, [])


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.report-average'),
          },
        ]}
        extras={
          <>
            {/* {checkPermission('CREATE') && (
              <div></div>
            )} */}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable<ReportAverageRatingOverTimeModel>
            bordered
            columns={columns}
            dataSource={dataReport}
            handleResize={() => { }}
            actionRef={tableRef}
            rowKey="stt"
            request={async (params = {}, sort, filter) => {
              let data: ReportAverageRatingOverTimeModel[] = [];
              if (dataSearch.fromTime && dataSearch.fromTime) {
                data = await getDataReport(dataSearch);
              }
              return {
                data: data,
                success: reportVisitCustomerSRStore.reportDDGTBTTG.isSuccess,
              };
            }}
            scroll={{ y: 400 }}
            options={false}
            pagination={false}


            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={loading.loading}
                onClick={async () => {
                  setLoading({ loading: true });

                  const { paging, ...rest } = dataSearch
                  await reportVisitCustomerSRPresenter.exportExcelBC4({ ...rest, env: VARIABLE_CHECK_ZALO, })
                  setLoading({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}

            summary={(data) => (
              <ProTable.Summary fixed>
                <ProTable.Summary.Row className='[&_.ant-table-cell]:!text-textBlack' >
                  <ProTable.Summary.Cell align='center' className='font-bold' colSpan={2} index={0}>Summary</ProTable.Summary.Cell>
                  {/* tổng rất kém */}
                  <ProTable.Summary.Cell align='right' className='font-bold' index={1}>{reportVisitCustomerSRStore.reportDDGTBTTG.data[data.length]?.diemDanhGiaTB}</ProTable.Summary.Cell>
                  {/* tổng kém */}
                  <ProTable.Summary.Cell align='right' className='font-bold' index={2}>{reportVisitCustomerSRStore.reportDDGTBTTG.data[data.length]?.diemDanhGiaTB2}</ProTable.Summary.Cell>
                </ProTable.Summary.Row>
              </ProTable.Summary>
            )}
          />




          <div className='mt-5'>
            <CustomBarChartBC4
              color={['#015874', '#ed7d31']}
              yAxisName={true}
              dataCol1={dataCol1}
              dataCol2={dataCol2}
              dataName={dataName}

              title={'Điểm đánh giá trung bình theo thời gian'}
              rotateLabel
            />
          </div>


        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[50%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              loading={loading.loadingSearch}
              type="primary"
              onClick={() => {
                const dateFromTo = form.getFieldValue('ngayDanhGia');
                const dateFromToBefore = form.getFieldValue('kyTruoc');
                const chiNhanh = form.getFieldValue('storeId');
                setDataSearch({
                  ...dataSearch,
                  storeId: chiNhanh ? chiNhanh : undefined,
                  fromTime: dateFromTo && dateFromTo[0] ? dayjs(dateFromTo[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTime: dateFromTo && dateFromTo[1] ? dayjs(dateFromTo[1])?.format(DATE_FORMAT_POST) : undefined,
                  fromTimeBefore: dateFromToBefore && dateFromToBefore[0] ? dayjs(dateFromToBefore[0])?.format(DATE_FORMAT_POST) : undefined,
                  toTimeBefore: dateFromToBefore && dateFromToBefore[1] ? dayjs(dateFromToBefore[1])?.format(DATE_FORMAT_POST) : undefined,
                  isShowroom: true
                });
                form.submit();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              tableRef.current?.reload();
            }}
            column="col-1"
            initialValues={{
              radioGroup: 2
            }}
          >
            {/* Công ty */}
            <SearchItem name={'companyId'} label={'Công ty'} col2>
              <CustomSelect
                options={listSaleOrg}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                onChange={async (value, option) => {
                  await getListBranch(value)
                }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>


            {/* <SearchItem name={'radioGroup'} label="Đối tượng đánh giá">
              <Radio.Group onChange={(e) => {
                if (e.target.value === 1) {
                  form.setFieldValue('storeId', [])
                } else {
                  form.setFieldValue('employee', [])
                }
              }}>
                <Radio value={1}>Theo nhân viên tiếp khách</Radio>
                <Radio value={2}>Theo showroom</Radio>
              </Radio.Group>
            </SearchItem> */}

            {/* showroom */}
            <SearchItem name={'storeId'} label={'Showroom'} col2>
              <CustomSelect
                options={listBranch}
                // disabled={disablefield === 1 || !disablefield}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
                showSearch
                mode='multiple'
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            </SearchItem>

            {/* user được đánh giá (danh sách tất cả các nhân viên) */}
            {/* <SearchItem name={'employee'} label={'User được đánh giá'} col2>
              <CustomSelect
                options={listCreateBy}
                // disabled={disablefield === 2 || !disablefield}
                mode='multiple'
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  searchCreateBy(value);
                }}
                allowClear
                showSearch
              />
            </SearchItem> */}

            {/* Ngày đánh giá  */}
            <SearchItem name={"commonDate"}
              rules={[{ required: true, message: "Vui lòng chọn ngày" }]}
              label={"Thời gian"} start col2>
              <CustomSelect
                options={listCommonDate}
                fieldNames={{ label: "value", value: "key" }}
                onChange={async (value, option) => {
                  if (option) {
                    setDisableRangePicker(
                      option.key === "Custom" ? false : true
                    );
                    await getDateByKey(option.key);
                  } else {
                    setDisableRangePicker(false);
                    form.setFieldValue("ngayDanhGia", undefined);
                  }
                }}
              />
            </SearchItem>
            {/* chọn ngày*/}
            <SearchItem name={"ngayDanhGia"} col2>
              <RangePicker
                disabled={disableRangePicker}
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>

            {/* chọn ngày (kỳ trước) */}
            <SearchItem name={"kyTruoc"} rules={[{ required: true, message: "Vui lòng chọn ngày" }]} label={"Chọn ngày (kỳ trước)"} col2>
              <RangePicker
                format="DD/MM/YYYY"
                className="w-full"
              />
            </SearchItem>

          </SearchForm>
        </SearchBox >
      </PageWrapper >
    )
  })

}

export default createPageAverageRatingOverTime